var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'message-row d-flex',
    { 'justify-end': _vm.message.own, 'justify-start': !_vm.message.own } ]},[_c('Message',{attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }